// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 19:48:51

export default {
  "id": "minicraft-winterblock",
  "slug": "minicraft-winterblock",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/b6c394d79f9e4948a8e13ec2cf7899ca-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/b6c394d79f9e4948a8e13ec2cf7899ca/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Minicraft Winterblock",
      "description": "Winter has arrived, and everything is covered in snow. In the snow-covered forest, you must be very careful to survive. You need to find two chests and collect all the snowballs. But be cautious, there are monsters everywhere waiting to eat you. You must defeat the monsters and reach the hidden portal at the end of the level. You must leave the house safely and pass through the portal.",
      "instructions": "*Played with WASD + Arrow Keys. \n*Mobile touch control is available.\n**Jump on monsters and crush them to kill them",
      "genres": [
        "Adventure",
        "Agility"
      ],
      "tags": [
        "1player",
        "2d",
        "arcade",
        "minecraft",
        "pixel"
      ]
    },
    "zh-CN": {
      "title": "迷你工艺冬块",
      "description": "冬天到了，一切都被雪覆盖。在雪覆盖的森林中，你必须非常小心才能生存。你需要找到两个宝箱并收集所有的雪球。但要注意，到处都是怪物在等着吃你。你必须击败怪物并到达关卡末尾的隐藏传送门。你必须安全地离开房子并通过传送门。",
      "instructions": "*使用WASD键加箭头键进行游戏。\n*提供移动触控控制。\n**跳到怪物身上并将它们压扁以杀死它们",
      "genres": [
        "冒险",
        "敏捷"
      ],
      "tags": [
        "1人",
        "2D",
        "街机",
        "我的世界",
        "像素"
      ]
    },
    "zh-TW": {
      "title": "迷你工坊冬季方塊",
      "description": "冬天的到來，一切都蓋滿了雪。在雪覆的森林裡，你必須非常小心才能生存。你需要找到兩個櫃子並收集所有的雪球。但請要小心，各處都有怪物在等待吃掉你。你必須擊敗怪物並達到等級末端的隱藏門。你必須安全離開房屋並通過門。",
      "instructions": "*使用WASD + 方向鍵玩遊戲。\n*提供手機觸控控制。\n**跳上怪物並壓碎它們來擊敗它們",
      "genres": [
        "冒險",
        "靈巧"
      ],
      "tags": [
        "1人遊玩",
        "2D",
        "街機",
        "礦工針對",
        "像素風格"
      ]
    },
    "zh-HK": {
      "title": "迷你工場冬日塊",
      "description": "冬日來臨，一切都被雪覆蓋。在白雪皚皚的森林中，你必須非常小心才能生存。你需要找到兩個櫃子並收集所有的雪球。但必須謹慎，各處都有怪物在等待吞噬你。你必須擊敗怪物並達到等級末端的隱藏傳送門。你必須安全離開屋內並穿過傳送門。",
      "instructions": "*以WASD + 方向鍵操控。\n*支援手機觸控控制。\n**跳上怪物並壓碎它們以殺死它們",
      "genres": [
        "冒險",
        "敏捷"
      ],
      "tags": [
        "1玩家",
        "2D",
        "街機",
        "Minecraft",
        "像素"
      ]
    },
    "ja": {
      "title": "マイクラウィンターブロック",
      "description": "冬が到来し、すべてが雪に覆われた。雪に覆われた森で、生き延びるために非常に慎重に行動しなければならない。二つの chestを見つけ、すべての snowballsを収集する必要がある。しかし、慎重に、あらゆる所にあなたを食べるために待つ怪物がいる。怪物を倒し、レベルの終わりに隠された portalに到達する必要がある。家を安全に離れ、portalを通過する必要がある。",
      "instructions": "*WASD + アームストロークキーで遊んでください。\n*モバイルタッチコントロールが利用可能です。\n**モンスターにジャンプして潰して倒しましょう。",
      "genres": [
        "アドベンチャー",
        "アギリティ"
      ],
      "tags": [
        "1プレイヤー",
        "2D",
        "アーケード",
        "マインクラフト",
        "ピクセル"
      ]
    },
    "ko": {
      "title": "미니크래프트 윈터블록",
      "description": "겨울이 왔고, 모든 것이 눈에 쌓였습니다. 눈이 쌓인 숲 속에서는 생존하기 위해 매우 조심스러워야 합니다. 두 상자를 찾고 모든 눈구름을 모으는必要가 있습니다. 하지만 조심하세요, 어디서든 몬스터들이 당신을 먹기 위해 기다리고 있습니다. 몬스터들을 물리치고 레벨의 끝에 숨겨진 포털에 도달해야 합니다. 집에서 안전하게 나가고 포털을 통해 통과해야 합니다.",
      "instructions": "* WASD + 방향키로 플레이하세요.\n* 모바일 터치 조종 가능.\n** 몬스터에 뛰어가 쳐부시고 죽이세요.",
      "genres": [
        "모험",
        "유연성"
      ],
      "tags": [
        "1플레이어",
        "2D",
        "아케이드",
        "마인크래프트",
        "픽셀"
      ]
    },
    "fr": {
      "title": "Minicraft Hiverblock",
      "description": "L'hiver est arrivé, et tout est recouvert de neige. Dans la forêt enneigée, vous devez être très prudent pour survivre. Vous devez trouver deux coffres et collecter tous les boulets de neige. Mais soyez prudent, il y a des monstres partout qui attendent de vous manger. Vous devez vaincre les monstres et atteindre le portail caché à la fin du niveau. Vous devez quitter la maison en toute sécurité et passer par le portail.",
      "instructions": "*Joué avec WASD + touches de direction.\n*Contrôle tactile mobile disponible.\n**Sauter sur les monstres et les écraser pour les tuer.",
      "genres": [
        "Aventure",
        "Agilité"
      ],
      "tags": [
        "1 joueur",
        "2D",
        "arcade",
        "Minecraft",
        "pixel"
      ]
    }
  }
};
